import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '../../services/translation/translate.service';
import { ClientService } from '../../services/client/client.service';
import { languageRegionCodesMap } from '../../constants';
import { LanguageRegionMap } from 'src/app/types';
import { StorageService } from '../../services/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class HomePageRedirectGuard {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private clientService: ClientService,
    private storageService: StorageService
  ) {}

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree
  > {
    const lang = this.translate.language as LanguageRegionMap;
    let regionCode: string | undefined;
    try {
      regionCode = languageRegionCodesMap[lang];
    } catch (error) {
      regionCode = 'en-en';
    }

    try {
      this.storageService.set('selectedLanguage', lang);
      await this.clientService.setClientV2({
        headers: { 'Accept-Language': regionCode },
      });
    } catch (error) {
      console.log('Error fetching client data');
    }

    const hasActiveLandingPage = this.clientService.client?.listOfNavbarItems?.find(i => i.isLanding);

    let landingPage = this.clientService.client?.isFullWeb
      ? 'home'
      : 'for-sale';

    if (hasActiveLandingPage) {
      landingPage = hasActiveLandingPage?.link?.slice(1, 99);
    }
    
    if (route?.url[1]?.path !== landingPage) {
      this.router.navigate([this.translate.language, landingPage]);
    }
    
    return true;
  }
}
